import React from 'react';
import DocumentForm from '../../components/forms/document-form';


export default function DocumentCapture() {
    return (
            <DocumentForm/>
    );
}
